module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/nano_02_sp-46120643e5860f2aa78916d3213cbdda.png";